import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { ExceptionTypes } from '../../feature/exception/exception.component';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {

    if (route.queryParams.token && !route.queryParams.error) {
      localStorage.setItem('esqep.auth.saml', route.queryParams.token);
      this.authService.loginSucceeded();
      this.authService.authenticationStatusSubj.next(true);
      if (route.queryParams.returnUrl) {
        window.location.href = route.queryParams.returnUrl;
      }
    }
   else if (localStorage.getItem('esqep.auth.saml') && localStorage.getItem('esqep.auth.saml').length > 0) {
      this.authService.loginSucceeded();
      this.authService.authenticationStatusSubj.next(true);
    }

    if (route.queryParams.error) {
      this.router.navigate([
        'exception',
        ExceptionTypes[ExceptionTypes.NOT_USER],
      ]);
      return of(false);
    }

    if (this.authService.isAuthenticated) {
      return of(true);
    }


    this.router.navigate(['login'], {
      queryParams: { returnUrl: state.url },
    });

    return of(false);
  }
}
